import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'AUTH',
  events: {
    'Start Load Required Data': emptyProps(),
    'Required Data Loaded Success': emptyProps(),
    'Switch Organization Requested': props<{ organizationId: string }>(),
    'Organization Switched': props<{ organizationId: string }>(),
    'Organization Switch Failed': props<{
      organizationId: string;
      message: string;
      status?: number;
    }>(),
    'Retry Organization Data Load': props<{ organizationId: string }>(),
    'Organization Data Loaded Success': props<{ organizationId: string }>(),
    'Organization Data Load Failed': props<{
      organizationId: string;
      message: string;
    }>(),
    'Redirect To Home': emptyProps(),
    Logout: props<{ msg: string | null }>(),
    'Logout Callback': emptyProps(),
    'Social Login By Code': props<{ code: string }>(),
  },
});
